<template>
  <div class="content pangu-components-table" id="pangu-components">
    <vxe-grid
      border='inner'
      resizable
      stripe
      showOverflow
      :data="tableData"
      :loading="loading"
      :columns="columns"
      ref="components"
      column-min-width="50"
      size="mini"
      row-id="id"
      :checkbox-config="checkboxConfig"
      @checkbox-change="handleCheckonComponent"
      :pager-config="pagerConfig"
      :tree-config="treeConfig"
      :filter-config="filterConfig"
      @page-change="handleChangePage"
      @sort-change="handleChangeSort">
      <template v-slot:status="{row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex}">
        <span :class="'component-status status-' + row.moderation_state" :title="row.moderation_state">
          ·
        </span>
      </template>
      <template v-slot:property="{row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex}">
        <span>
          {{_.get(row, column.props.spec)}}
        </span>
      </template>
      <template v-slot:stock="{row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex}">
          <ErpStocks v-if="row.part_identity"
            :partNumber="_.get(row.part_identity, 'part_number')">
          </ErpStocks>
      </template>
      <template v-slot:spec-display-value="{column, row}">
        {{ getSpecValue(row, column.params.spec) }}
      </template>
      <template v-slot:spec-filter="{column, columnIndex, $columnIndex}">
        <Select v-model="search.specs[column.params.spec]" :placeholder="_.get(column.props, 'meta.name')"
          filterable clearable
          size="small"
          >
          <label slot="prefix" class="label-prefix">
            <Badge dot v-if="_.get(column.params, 'in_category')" type="info">
              {{ !!_.get(column.params, 'meta.chinese_name') ? _.get(column.params, 'meta.chinese_name') : _.get(column.params, 'meta.name') }}:
            </Badge>
            <span v-else>
              {{ !!_.get(column.params, 'meta.chinese_name') ? _.get(column.params, 'meta.chinese_name') : _.get(column.params, 'meta.name') }}:
            </span>
          </label>
          <Option
            v-for="(spec, index) in column.filters"
            :value="spec.key"
            :key="spec.key + '.values.' + index"
            :label="spec.key">
              {{spec.key}}  <span class="search-count">( {{spec.doc_count}} )</span>
          </Option>
        </Select>
      </template>
      <template v-slot:operation="{row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, _columnIndex}">
        <router-link :to="{ name: 'menu.electronic_part.edit', params: { 'partId': row.id } }" target="_blank"><Icon type="md-create"></Icon></router-link>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import ErpStocks from '@/view/part/components/stocks'
Vue.use(VXETable)

export default {
  name: 'PanguComponents',
  components: {
    ErpStocks
  },
  props: {
    components: {
      type: Array
    },
    filters: {
      type: Object,
      default: () => {
        return {
          keyword: '',
          matches: {
            mpn: null,
            brand: null
          },
          terms: { moderation_state: null, component_type: 'electronic_part' },
          specs: {},
          exists: {},
          aggs: {}
        }
      }
    },
    showCheckbox: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      showPartFormDrawer: false,
      manufacturerPartId: null,
      tableData: [],
      total: 0,
      sort: { '_score': 'desc' },
      currentPage: 1,
      pageSize: 15,
      selectedComponets: [],
      search: {
        keyword: '',
        matches: {
          mpn: null,
          brand: null
        },
        terms: { moderation_state: null, component_type: 'electronic_part' },
        specs: {},
        exists: {},
        aggs: {}
      },
      includes: ['manufacturer', 'partIdentity', 'specs.meta'],
      filterConfig: {
        remote: true
      },

      treeConfig: {
        lazy: false,
        children: 'substitutions',
        hasChild: 'has_substitutions',
        line: false
      },
      checkboxConfig: {
        // checkField: 'id',
        checkMethod: this.allowChecked,
        trigger: 'row'
      },
      columns: [
      ],
      mainColumns: [
        { type: 'checkbox', field: 'id', title: '', width: 40, fixed: 'left', visible: this.showCheckbox },
        { field: 'status', title: 'Status', width: 60, fixed: 'left', slots: { default: 'status' } },
        { field: 'part_identity.part_number', title: 'Part number', minWidth: 100, remoteSort: false, fixed: 'left' },
        { field: 'mpn', title: 'MPN', minWidth: 160, remoteSort: false, fixed: 'left' },
        { field: 'brand', title: 'Brand', minWidth: 90, remoteSort: false, fixed: 'left' },
        { field: 'chinese_name', title: 'Name(chinese)', minWidth: 140, remoteSort: true },
        { field: 'name', title: 'Name', minWidth: 140, remoteSort: true },
        { field: 'specification', title: 'Specification', minWidth: 300, remoteSort: false },
        { field: 'stock', title: 'Stock', minWidth: 80, remoteSort: false, slots: { default: 'stock' } }
      ],
      specColumns: [

      ],
      actionColumns: [
        { field: 'edit', title: 'Action', minWidth: 80, remoteSort: false, slots: { default: 'operation' }, fixed: 'right' }
      ],
      sortConfig: {
        trigger: 'cell'
      }
    }
  },
  watch: {
    filters: {
      handler: function (filters) {
        this.search = _.cloneDeep(filters)
      },
      deep: true
    }
  },
  computed: {
    pagerConfig: function () {
      return {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        total: this.total,
        pageSizes: [10, 15, 50, 100]
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions([
      'getErpStocks',
      'searchManufacturerPart',
      'getPartSpecMetadatas'
    ]),
    async init() {
      this.selectedComponets = []
      this.search = this.filters
      this.sort = { '_score': 'desc' }
      this.tableData = []
      this.total = 0
      this.currentPage = 1
      await this.generateSpecColumns()
      this.columns = _.concat(this.mainColumns, this.specColumns, this.actionColumns)
      this.$nextTick(() => {
        if (this.$route.query && this.$route.query.id) {
          this.manufacturerPartId = this.$route.query.id
          this.$refs.partForm.loadPart(this.manufacturerPartId)
          this.showPartFormDrawer = true
        }
      })
    },
    handleLoadParts () {
      this.loading = true
      return this.searchManufacturerPart({
        size: this.pageSize,
        page: this.currentPage,
        includes: this.includes,
        exists: this.search.exists,
        appends: ['substitute_components', 'substitute_parents'],
        sort: this.sort,
        matches: this.search.matches,
        terms: this.search.terms,
        keyword: this.search.keyword,
        specs: this.search.specs,
        aggs: this.search.aggs
      }).then((res) => {
        this.total = _.toNumber(res.meta.total)
        this.currentPage = _.toNumber(res.meta.current_page)
        this.pageSize = _.toNumber(res.meta.per_page)
        this.tableData = res.data
        this.$emit('onComponentsLoaded', res)
        this.setSpecColumnVisible(res.data)
        this.handleLoadStocks(this.tableData)
        this.selectedComponets = []
        this.$emit('update:components', this.selectedComponets)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSetTableColumns(res) {
      this.setSpecMetaAggFilter(res.aggs)
      this.columns = _.concat(this.mainColumns, this.specColumns, this.actionColumns)
    },
    getSpecValue(component, specKey) {
      let findSpec = _.find(component.specs, (spec) => {
        return spec.key === specKey
      })
      if (findSpec) {
        return findSpec.display_value
      }
      return null
    },
    setSpecColumnVisible (components) {
      let usedSpecKeys = []
      _.each(components, component => {
        let specKeys = _.map(component.specs, spec => {
          return spec.key
        })
        usedSpecKeys = _.uniq(_.concat(usedSpecKeys, specKeys))
      })
      _.each(this.specColumns, specColumn => {
        let column = this.$refs.components.getColumnByField(specColumn.field)
        column.visible = false
      })
      _.each(usedSpecKeys, specKey => {
        let column = this.$refs.components.getColumnByField('spec_' + specKey)
        if (column) column.visible = true
      })
      this.$nextTick(() => {
        this.$refs.components.refreshColumn()
      })
    },
    async generateSpecColumns() {
      this.specColumns = []
      let result = await this.getPartSpecMetadatas().then(res => {
        _.each(res, (meta) => {
          this.specColumns.push({
            field: 'spec_' + meta.key,
            title: meta.chinese_name ? meta.chinese_name : meta.name,
            showHeaderOverflow: true,
            minWidth: 130,
            params: {
              spec: meta.key,
              meta: meta
            },
            visible: false,
            slots: {
              default: 'spec-display-value',
              filter: 'spec-filter'
            }
          })
          return this.specColumns
        })
      })
      return result
    },
    setSpecMetaAggFilter(aggResults) {
      let res = _.get(aggResults, 'spec_metas.keys.buckets', [])
      if (!_.isEmpty(res)) {
        let facets = []
        _.each(res, (n) => {
          let specMeta = this.findSpecMeta(n.key)
          if (specMeta) {
            specMeta.doc_count = n.doc_count
            specMeta.weight = 99999
            facets.push(_.clone(specMeta))
          }
        })
        if (this.category && this.category.main_specs) {
          let weight = 0
          _.each(this.category.main_specs, (mainSpec) => {
            let findFacet = _.find(facets, (s) => {
              return s.key === mainSpec.key
            })
            if (findFacet) {
              findFacet.weight = weight
              findFacet.in_category = true
            }
            weight++
          })
        }
        this.specMetaFilters = _.clone(_.sortBy(facets, [function(o) { return o.weight }]))
      }
    },
    setSpecMetaFacetValues(aggResults) {
      let res = _.get(aggResults, 'spec_metas.keys.buckets', [])
      _.each(res, (n) => {
        let specMeta = this.findSpecMeta(n.key)
        if (specMeta) {
          let facetOptons = _.get(aggResults, specMeta.key + '.keys.values.buckets', null)
          if (facetOptons) {
            this.$set(this.specFacetValues, specMeta.key, facetOptons)
          }
        }
      })
    },
    findSpecMeta(key) {
      return _.clone(_.find(this.specMetadatas, (s) => {
        return s.key === key
      }))
    },
    handleAddNewComponent () {
      this.$router.push({ name: 'menu.electronic_part.new' })
    },
    handleLoadStocks (tableData) {
      let partNumbersZiped = _.map(tableData, (row) => {
        if (row.part_identity) {
          return [row.part_identity.part_number]
        } else {
          return []
        }
      })
      let partNumbers = _.union(...partNumbersZiped)
      this.getErpStocks({ part_numbers: partNumbers })
    },
    handleChangePage ({ type, currentPage, pageSize, $event }) {
      this.currentPage = currentPage
      this.pageSize = pageSize
      this.handleLoadParts()
    },
    handleChangeSort({ column, property, order, $event }) {
      this.sort = {}
      this.$set(this.sort, property, order)
      this.handleLoadParts()
    },
    handleCheckonComponent({ records, reserves, indeterminates, checked, row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }) {
      this.selectedComponets = records
      this.$emit('update:components', this.selectedComponets)
    },
    allowChecked({ row }) {
      return true
    }
  }
}
</script>

<style lang="less">
#component-form-drawer {
  .ivu-drawer-mask{
    z-index: 5501;
  }
  .ivu-drawer-wrap {
    z-index: 5502;
  }
}
.component-status {
  font-size: 36px;
  &.status-reviewed{
    color: #19be6b;
  }
  &.status-draft{
    color: #ff9900;
  }
  &.status-invalid{
    color: #ed4014;
  }
}
</style>
